import styled from 'styled-components'
import { mediaqueries } from '~/utils/mediaqueries'
import Button from '~/components/Button'

export const ProductForm = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;


  ${({ theme: { toRem, color } }) => `
    padding: 0 !important;
    background: ${color('accent', 80)};
  `}

  @media ${mediaqueries.md} {
    padding: 1rem 0 !important;  
    background: transparent;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${mediaqueries.md} {
    ${({ theme: { toRem } }) => `
        margin-bottom: ${toRem(40)};
      `};
  }
`

export const ResetButton = styled(Button)`
  margin: 0 30px 10px;
  align-self: center;
`
